import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  wrapper: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    padding: '150px 0',
  },
  messageWrapper: {
    minWidth: '550px',
    margin: '0',
    position: 'unset',
  },
  cardWrapper: {
    marginTop: '16px',
  },
});

export default useStyles;
